import { Navigate, RouteObject } from "react-router-dom";
import AboutView from "../pages/AboutView";
import CheckoutInProgressPage from "../pages/Checkout/CheckoutInProgressPage";
import StartCheckoutPage from "../pages/Checkout/StartCheckoutPage";
import EventView from "../pages/Events/EventView";
import NotFound from "../pages/NotFound";
import OrderReceiptPage from "../pages/Orders/OrderReceiptPage";
import OrdersPage from "../pages/Orders/OrdersPage";

export const eventsRoutes: RouteObject[] = [
    { path: "/events", element: <Navigate to='/' /> },
    { path: "/events/:eventId", element: <EventView /> },
    { path: "/events/:eventId/:imageId", element: <EventView /> },
    { path: "/checkout", element: <StartCheckoutPage /> },
    { path: "/checkout/:orderId", element: <CheckoutInProgressPage /> },
    { path: "/orders/:orderId", element: <OrdersPage /> },
    { path: "/orders/:orderId/receipt", element: <OrderReceiptPage /> },
    { path: "/about", element: <AboutView /> },
    { path: "*", element: <NotFound /> },
];
